// src/config/subscriptions.js
//
// Sprint 2c-2a foundation: subscription lifecycle constants.
// Migrated verbatim from prototype/between-the-lines-v2.html line 6146.
//
// Used by: subscriptionHelpers.js (getSubStatus); admin status badge (Sprint 3).

export const SUBSCRIPTION_WARN_DAYS = 14;
